module.exports = __webpack_public_path__ + "static/img/icon_group_3.e769c41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/icon_group_3.png
// module id = A386
// module chunks = 0